<script setup lang="ts">
import { Head, Link } from '@inertiajs/vue3'
import InternalLayout from '@/layouts/InternalLayout.vue'
</script>

<template>
  <InternalLayout title="Referral Program" hero-image="/img/family-enjoying-green-lawn.jpg" hero-position="center 30%">
    <Head title="Referral Program">
      <meta head-key="description" name="description" content="Join the Mow Managers Neighbor Rewards referral program. Refer friends and neighbors and earn a $100 Mastercard gift card after 10 referrals." />
      <link rel="canonical" href="https://mowmanagers.com/referral-program" />
      <meta property="og:title" content="Referral Program - Mow Managers" />
      <meta property="og:description" content="Refer friends and neighbors to Mow Managers and earn a $100 Mastercard gift card after 10 referrals." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://mowmanagers.com/referral-program" />
    </Head>

    <!-- ==================== REFERRAL CONTENT ==================== -->
    <section aria-labelledby="referral-heading" class="bg-white py-20 lg:py-28">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <div>
            <h2 id="referral-heading" class="text-3xl font-bold text-mm-green sm:text-4xl lg:text-[48px] lg:leading-[56px]">
              Fertilize Your<br />Bank Account
            </h2>

            <h3 class="mt-8 text-[16px] font-extrabold tracking-[1.4px] text-mm-dark uppercase">
              Turn Referrals Into Free Lawn Care
            </h3>
            <p class="mt-3 text-[16px] leading-[26px] font-medium text-[#6d706d]">
              Ever wish you could turn talking to friends and neighbors into a side hustle? Now, you can. Just mention us to someone and when they hire us for on going service you will get a free mow. Yes, it's that easy.
            </p>

            <h3 class="mt-8 text-[16px] font-extrabold tracking-[1.4px] text-mm-dark uppercase">
              How Does It Work?
            </h3>
            <p class="mt-3 text-[16px] leading-[26px] font-medium text-[#6d706d]">
              Make sure you have a active account with us. Then start spreading the word. We'll let you know when you have a free mow to claim.
            </p>
          </div>

          <div class="overflow-hidden rounded-[20px]">
            <img
              src="/img/bottom-square-2.webp"
              alt="Beautiful home with a well-maintained lawn"
              class="h-[400px] w-full object-cover lg:h-[500px]"
              width="640"
              height="500"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  </InternalLayout>
</template>
